var req = require("!!/opt/build/repo/node_modules/pug-loader/index.js!/opt/build/repo/src/app/shared/components/title-bar/title-bar.component.pug");
module.exports = (req['default'] || req).apply(req, [])